import { T } from '@tribeplatform/react-components/i18n'

import type { TableCounterProps } from './types.js'

export const TagsCounter = ({
  matchedCount,
  totalCount,
}: TableCounterProps) => {
  return (
    <div className="flex items-center space-s-1">
      {totalCount === matchedCount ? (
        <span className="font-medium">
          <T
            defaultMessage="{tags_count, plural, zero {No {TAGS}} one {# {TAG}} other {# {TAGS}}}"
            id="Generics.Tags.Plural"
            values={{
              tags_count: totalCount,
            }}
          />
        </span>
      ) : (
        <span>
          <T
            defaultMessage="<bold>{matched_count, plural, one {# {TAG}} other {# {TAGS}}} matched</bold> of {total_count, number}"
            id="Admin.TagsList.TableCounter"
            values={{
              matched_count: matchedCount,
              total_count: totalCount,
              bold: chunks => <span className="font-medium">{chunks}</span>,
            }}
          />
        </span>
      )}
    </div>
  )
}
